import {useContext} from "react";
import {MyContext} from "../context/myContext";

const FormikInput = ({data, formik, handleChange, handleOnFocusOut, formType, nameInRequest, nameLoading}) => {
    const {formTitle} = useContext(MyContext)
    return(
        data.map((item, index) => {
            const isNameInput = formType === 'addReqForm' && item.name === 'name';
            return(
                formTitle === 'ویرایش کاربر' && item.name === 'password' ? null :
                    <div key={index} className='relative'>
                        <input 
                            type={item.name === 'password' ? 'password' : 'text'} 
                            name={item.name} 
                            placeholder={isNameInput && nameLoading ? 'در حال جستجو...' : item.placeholder}
                            value={(formType === 'addReqForm' && item.name === 'name') ? nameInRequest : formik.values[item.name]}
                            onChange={handleChange} 
                            onBlur={(formType === 'addReqForm' && item.name === 'code') ? handleOnFocusOut : undefined}
                            className={`focus:shadow-focusShadow hover:border-green-500 ${isNameInput && nameLoading ? 'opacity-60' : ''}`}
                            readOnly={(formType === 'addReqForm' && item.name === 'name') ||
                                (formType === 'editReqForm' && (item.name !== 'waterVolume' && item.name !== 'cost' && item.name !== 'deliverTime'))}
                        />
                       
                        {isNameInput && nameLoading && (
                            <i className='fa fa-spinner fa-spin absolute left-2 top-1/2 -translate-y-1/2 text-green-500'></i>
                        )}
                        {formType ? <label>{item.placeholder}{(item.placeholder !== 'کد پیگیری' && item.placeholder !== 'نام درخواست دهنده'
                            && item.placeholder !== 'نام متقاضی(براساس کدملی)' && item.name !== 'population' && item.name !== 'insuredLiveStock')
                            && <span>*</span>}</label> : <span>*</span>}
                        {formType !== 'addReqForm' && formType !== 'editReqForm' && formik.values[item.name] !== '' && <i>{item.hint}</i>}
                        {formik.touched[item.name] && formik.errors[item.name] ? <p className='error'>{formik.errors[item.name]}</p> : null}
                    </div>
            )
        })
    )
}
export default FormikInput